var _style, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPsychic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Rectangle-2_2_);}\r\n\t.st1{fill:url(#Rectangle-2_3_);}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Types_Poison",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 61.5333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A864C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C261D4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_1_",
    className: "st0",
    d: "M36,0L36,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Types_Psychic",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 59.1333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F66F71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE9F92"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st1",
    d: "M36,0L36,0c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36l0,0C16.1,72,0,55.9,0,36l0,0 C0,16.1,16.1,0,36,0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st2",
    d: "M33.1,32.1c0,0-4.2,3.4-12.7,2c-6.4-1.1-9.8-8.1-9.8-11.9c0-9,6.7-11,11.1-11 c4.1,0.3,7.4,3.6,7.4,7.8c0.1,3.4-2.5,6.2-5.8,6.4c-0.1,0-0.2,0-0.3,0c-2.5,0.2-4.7-1.7-4.9-4.2c0-0.3,0-0.6,0-0.9 c0-1.8,1.5-3.3,3.3-3.3c0.1,0,0.3,0,0.4,0c1.8,0,2.4,1.5,2.4,2.8c0,0.9-0.7,1.7-1.7,1.8c-0.1,0-0.1,0-0.2,0 c-0.8,0-0.9-0.4-1.3-0.9s0.4-2.1-0.8-2.1S19,20.5,19,20.5c0.2,2.1,2,3.7,4.1,3.7c2.6,0.2,4.8-1.8,4.9-4.4c0-0.4,0-0.8-0.1-1.3 c-0.8-3.6-4.3-5.9-7.9-5.1c-4.7,0.6-6.7,5.4-5.8,10.5s7,8.1,11.8,7c4.8-1.1,9.6-4.5,9.6-13.4S28,3.4,18.8,4.3S4.1,13.1,4.4,22.7 s9.5,14.8,17.1,15.1c4.5,0.2,8.9-1.3,12.4-4.2c0,0,1.1-0.9,0.6-1.7C34.2,31.2,33.1,32.1,33.1,32.1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychic);
export default __webpack_public_path__ + "static/media/psychic.a00a30eb9975b9833e5ee2a81a32a000.svg";
export { ForwardRef as ReactComponent };